<script>
import {mapActions, mapGetters} from "vuex";
import {
  getBusinessCardsDoc, getQueryBusinessCardsCollection, getQueryByCollectionName, queryByCollectionName,
  queryConnectionsCollection,
  queryEventAttendeesCollection
} from "@/shared/firebase_utils";
import {where, limit, getCountFromServer, getDocs, startAfter, query} from "firebase/firestore";
import Loading from "@/components/Loading.vue";

export default {
  name: "PartnerAnalyticsDetails",
  components: {Loading},
  data() {
    return {
      partnersData: [],
      type: null,
      currentEventId: null,
      headers: [
        {
          text: "",
          value: "image",
          align: "end",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "# of profile views",
          value: "profileViews",
          align: "start",
        },
        {
          text: "# of representatives",
          value: "representatives",
          align: "start",
        },
        {
          text: "# of connections made",
          value: "connectionsMade",
          align: "start",
        },
      ],
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    breadCrumbItems() {
      if (this.currentEvent) {

        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 5}
          },
          {
            text: 'Analytics',
            disabled: false,
            routeName: "editMultiConnect",
            params: {
              eventId: this.currentEvent.id,
            },
            query: {tab: 5}
          },
          {
            text: this.type,
            disabled: true,
            routeName: "partnerAnalytics",
            params: {
              eventId: this.currentEvent.id,
            },
          },
        ];
        return items;
      } else return [];
    },

    headerDetails() {
      return [
        {
          title: "profile views",
          icon: "account-eye",
          value: this.partnersData.reduce((total, item) => total + item.profileViews, 0),
        },
        {
          title: "representatives",
          icon: "account-star",
          value: this.partnersData.reduce((total, item) => total + item.representatives, 0)
        },
        {
          title: "connections made",
          icon: "account-group-black",
          value: this.partnersData.reduce((total, item) => total + item.connectionsMade, 0)
        },
      ];
    },
  },
  methods: {
    ...mapActions(["initializeCurrentEvent"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    async getPartnersRepresentativesDetails(partner) {
      let totalRepresentatives = 0;
      let totalConnectionsMade = 0;
      if (partner.businessProfileId) {
        const representatives = await getQueryBusinessCardsCollection(
            where("businessProfileId", "==", partner.businessProfileId),
            where("partnerRepresentativeParentEventId", "==", this.currentEventId));
        totalRepresentatives = representatives.size;
        const representativeBusinessCardIds = representatives.docs.map(doc => doc.id);
        if(representativeBusinessCardIds  && representativeBusinessCardIds.length && representativeBusinessCardIds.length > 0) {
          const connectionsCountQuery = Promise.all(representativeBusinessCardIds.map(businessCardId => getCountFromServer(
              queryConnectionsCollection(
                  where("businessCardIds", "array-contains", businessCardId),
                  where("isAccepted", "==", true)
              )
          )));
          totalConnectionsMade = (await connectionsCountQuery).map(count => count.data().count).reduce((total, count) => total + count, 0);
          }else{
          console.log("No representatives found");
        }
      }
      const profileViewsForThisPartner = this.currentEvent.sponsorsAnalytics.filter(analytics => analytics.sponsorUid === partner.sponsorDocRef);
      const clickCount = profileViewsForThisPartner.reduce((total, item) => {
        const count = item.clickData.reduce((sum, clickData) => {
          return sum + clickData.clickCount
        }, 0);
        console.log(count);
        return total + count;
      }, 0)
      return {
          displayImageUrl: partner.logoURL,
          businessName: partner.name,
          profileViews: clickCount,
          representatives: totalRepresentatives,
          connectionsMade: totalConnectionsMade,
        };
    },
    async getPartnersData() {
      const isFeaturedCompany = this.type.toLowerCase() === "scaleups" || this.type.toLowerCase() === "startups";
      const collectionName = isFeaturedCompany ? "featuredCompanies" : "sponsors";
      console.log(collectionName);
      let partnersQuery = queryByCollectionName(collectionName, where("eventId", "==", this.currentEventId));
      if (isFeaturedCompany) {
        partnersQuery = query(partnersQuery, where("promoterType", "==", this.type.toLowerCase().slice(0, -1)));
      }
      const partners = (await getDocs(partnersQuery)).docs.map(doc => doc.data());
      console.log(partners.length);
      const data = await Promise.all(partners.map(partner => this.getPartnersRepresentativesDetails(partner)));
      this.partnersData = data;
    },
    async saveEvent() {
      await this.initializeCurrentEvent(this.currentEventId);
      await this.getPartnersData();
    }
  },
  created() {
    this.type = this.$route.query.type;
    this.currentEventId = this.$route.params.eventId;
    this.saveEvent();
  }
}
</script>

<template>
  <v-container fluid :class="currentEvent == null || !this.partnersData ? 'fill-height' : ''">
    <v-row v-if="currentEvent == null || !this.partnersData">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>
            {{this.type}}
          </v-card-title>
          <v-col>
            <v-row>
              <div v-for="item in headerDetails">
                <div style="background-color: #F6F7FC; border-radius: 6px" class="ma-4">
                  <v-row class="ma-auto px-4 py-2" align="center">
                    <img :src="require(`@/assets/icons/${item.icon}.svg`)" height="30" width="35" style="color: black"
                         class="pr-2">{{ item.value }} {{ item.title }}
                  </v-row>
                </div>
              </div>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="partnersData"
                :items-per-page="-1"
                hide-default-footer
            >
              <template v-slot:[`item.image`]="{ item }">
                <v-img class="rounded-lg" width="51.03" height="33.75" max-width="51.03" max-height="33.75"
                       :src="item.displayImageUrl">
                </v-img>
              </template>
              <template v-slot:[`item.businessName`]="{ item }">
                <span>{{ item.businessName }}</span>
              </template>
              <template v-slot:[`item.profileViews`]="{ item }">
                <span>{{ item.profileViews }}</span>
              </template>
              <template v-slot:[`item.representatives`]="{ item }">
                <span>{{ item.representatives }}</span>
              </template>
              <template v-slot:[`item.connectionsMade`]="{ item }">
                <span>{{ item.connectionsMade }}</span>
              </template>
            </v-data-table>

          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<style scoped>

</style>